import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
export default /*#__PURE__*/React.memo(function (props) {
  var onClick = function onClick(e) {
    var _props$selectProps;
    e.stopPropagation();
    var newValue = [];
    if (((_props$selectProps = props.selectProps) === null || _props$selectProps === void 0 || (_props$selectProps = _props$selectProps.value) === null || _props$selectProps === void 0 ? void 0 : _props$selectProps.length) > 0) {
      newValue = props.selectProps.value.filter(function (current) {
        return current.value !== props.data.value;
      });
    }
    props.selectProps.onChange(newValue, {
      action: 'remove-value',
      option: props.data
    });
  };
  return components.MultiValueRemove && /*#__PURE__*/React.createElement(components.MultiValueRemove, props, /*#__PURE__*/React.createElement(Icon, {
    name: "closeSmall",
    onClick: onClick
  }));
});